import React from 'react';
import { useTranslation } from 'react-i18next';

export type ReportNoteCardProps = {
  note?: string;
};
export const ReportNoteCard = ({ note }: ReportNoteCardProps) => {
  const { t } = useTranslation();

  if (!note) return null;
  return (
    <div className="tw-mt-6 tw-w-full tw-break-inside-avoid tw-whitespace-pre-wrap tw-break-words tw-rounded-md tw-bg-grayscale-5 tw-p-6">
      <span className="tw-font-semibold">
        {t('pdfReports.notes.label')}&nbsp;
      </span>
      {note}
    </div>
  );
};
